'use strict';

var React = require('react');

var SvgMetafieldsFilledIcon = function SvgMetafieldsFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 5.5c0-.828.672-1.5 1.5-1.5h1c.828 0 1.5.672 1.5 1.5v.5h2v-.5c0-.828.672-1.5 1.5-1.5h1c.828 0 1.5.672 1.5 1.5v1.273l.417.196c.966.453 1.583 1.423 1.583 2.49v3.791c0 1.519-1.231 2.75-2.75 2.75h-8.5c-1.519 0-2.75-1.231-2.75-2.75v-3.791c0-1.067.617-2.037 1.583-2.49l.417-.196v-1.273Zm.75 4c-.414 0-.75.336-.75.75s.336.75.75.75h8.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-8.5Z"
  }));
};
SvgMetafieldsFilledIcon.displayName = "MetafieldsFilledIcon";

exports.SvgMetafieldsFilledIcon = SvgMetafieldsFilledIcon;
